import { Capacitor } from '@capacitor/core';
import { Camera } from '@capacitor/camera';
import { VoiceRecorder } from 'capacitor-voice-recorder';
import { defineCustomElements } from '@ionic/pwa-elements/loader';

// Expose Capacitor gloablly
window.Capacitor = Capacitor;
// Expose Plugins globally (Camera specifically needs to be registered this way or just imported)
// For the web, when we import it, it usually registers itself with the core.
// However, to mimic how our app accesses it via Capacitor.Plugins.Camera:
Capacitor.Plugins = Capacitor.Plugins || {};
Capacitor.Plugins.Camera = Camera;
Capacitor.Plugins.VoiceRecorder = VoiceRecorder;

// Initialize PWA Elements (for camera, toast, etc.)
defineCustomElements(window);

console.log('Capacitor Web initialized with Camera & VoiceRecorder');
